/**
 * Determines the type of a sidebar selection by searching allSidebarItems.
 *
 * @param {string} selectedItemId - The selected sidebar item ID
 * @param {Array} allSidebarItems - All sidebar items including buildings with nested floors
 * @returns {"inbox"|"building"|"floor"|null} The item type, or null if not found
 */
function getSelectionType(selectedItemId, allSidebarItems) {
  for (const item of allSidebarItems) {
    if (item.id === selectedItemId) return item.type
    if (item.floors) {
      for (const floor of item.floors) {
        if (floor.id === selectedItemId) return floor.type
      }
    }
  }
  return null
}

/**
 * Filters files based on the current sidebar selection.
 *
 * - Inbox: files with no building_zone_id (unassigned)
 * - Building: files with matching building_zone_id
 * - Floor: files with matching placed_on_zone_id
 *
 * @param {Array|null} files - All uploaded file objects
 * @param {string} selectedItemId - Currently selected sidebar item ID
 * @param {Array} allSidebarItems - All sidebar items (inbox + buildings with nested floors)
 * @returns {Array} Filtered files for the current selection
 */
export function filterFilesBySidebarSelection(files, selectedItemId, allSidebarItems) {
  if (!files || files.length === 0) return []

  const selectionType = getSelectionType(selectedItemId, allSidebarItems)

  switch (selectionType) {
    case "inbox":
      return files.filter(f => f.building_zone_id == null)
    case "building":
      return files.filter(f => f.building_zone_id === selectedItemId)
    case "floor":
      return files.filter(f => f.placed_on_zone_id === selectedItemId)
    default:
      return []
  }
}
